import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { firebaseStateReducer } from 'react-redux-firebase';

const rootReducer = combineReducers({
  firebase: firebaseStateReducer,
  routing: routerReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.jsx